import { useRouterState } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * Hook to get the current route's translated title from staticData
 * Translates translation keys found in staticData.title
 */
export const useRouteTitle = () => {
  const currentMatch = useRouterState({
    select: (state) => state.matches[state.matches.length - 1],
  });
  const { t } = useTranslation(['periverse']);

  const title = currentMatch?.staticData?.title;

  // If title is a translation key (contains dots), translate it
  if (title && title.includes('.')) {
    return t(title, title); // Use the key as fallback
  }

  // Otherwise return the title as-is (fallback for non-translation keys)
  return title || t('pages.caseSchedule.title', 'Case Schedule');
};
